import React from 'react';
import { UserCheckIcon, PlaneIcon, ShieldCheckIcon, ClockIcon, AwardIcon, MessageCircleIcon } from 'lucide-react';
import { useLanguage } from '../hooks/useLanguage';
export function TrustBar() {
  const {
    language
  } = useLanguage();
  const content = {
    en: [{
      text: 'Meet & Greet at Airport',
      icon: UserCheckIcon
    }, {
      text: 'Flight Tracking Included',
      icon: PlaneIcon
    }, {
      text: 'Fixed Prices – No Surprises',
      icon: ShieldCheckIcon
    }, {
      text: '24/7 Availability',
      icon: ClockIcon
    }, {
      text: 'Professional Local Drivers',
      icon: AwardIcon
    }],
    es: [{
      text: 'Recepción en el aeropuerto',
      icon: UserCheckIcon
    }, {
      text: 'Seguimiento de vuelo incluido',
      icon: PlaneIcon
    }, {
      text: 'Precios fijos – Sin sorpresas',
      icon: ShieldCheckIcon
    }, {
      text: 'Disponibilidad 24/7',
      icon: ClockIcon
    }, {
      text: 'Conductores locales profesionales',
      icon: AwardIcon
    }]
  };
  const mobileExtra = {
    en: {
      text: 'Reply in Under 2 Minutes',
      icon: MessageCircleIcon
    },
    es: {
      text: 'Respuesta en menos de 2 minutos',
      icon: MessageCircleIcon
    }
  };
  const items = content[language];
  const extraItem = mobileExtra[language];
  return <div className="bg-warm-cream border-y border-stone/10 py-6 md:py-8" data-id="element-307">
      <div className="mx-auto max-w-7xl px-5" data-id="element-308">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-4 md:gap-6" data-id="element-309">
          {items.map((item, index) => {
          const Icon = item.icon;
          return <div key={index} className="flex flex-col items-center text-center space-y-3" data-id="element-310">
                <div className="w-10 h-10 rounded-full bg-warm-white flex items-center justify-center" data-id="element-311">
                  <Icon className="w-4 h-4 text-gold-subtle" data-id="element-312" />
                </div>
                <span className="text-xs md:text-sm font-medium text-slate leading-tight" data-id="element-313">
                  {item.text}
                </span>
              </div>;
        })}
          <div className="flex flex-col items-center text-center space-y-3 md:hidden" data-id="element-314">
            <div className="w-10 h-10 rounded-full bg-warm-white flex items-center justify-center" data-id="element-315">
              <MessageCircleIcon className="w-4 h-4 text-gold-subtle" data-id="element-316" />
            </div>
            <span className="text-xs font-medium text-slate leading-tight" data-id="element-317">
              {extraItem.text}
            </span>
          </div>
        </div>
      </div>
    </div>;
}